module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-swap-white-18e632.svg";